import { useState } from 'react';
import { signupFields } from "../constants/formFields"
import FormAction from "./FormAction";
import Input from "./Input";
import { registerUser } from '../services/api';
import { useNavigate } from "react-router-dom"

const fields = signupFields;
let fieldsState = {};

fields.forEach(field => fieldsState[field.id] = '');

export default function Signup() {
    const [signupState, setSignupState] = useState(fieldsState);
    const [formErrors, setFormErrors] = useState({});
    const [permissionError, setPermissionError] = useState()

    const navigate = useNavigate()

    const handleChange = (e) => {
        setPermissionError('')
        setSignupState({ ...signupState, [e.target.id]: e.target.value })
        clearError(e.target.id);
    };

    const handleSubmit = (e) => {
        e.preventDefault()
        validateForm()
    }

    const validateForm = async () => {
        const errors = {};

        if (signupState.username.length === 0) {
            errors.username = 'Username cannot be empty'
        }

        if (signupState.email.length === 0) {
            errors.email = 'Email Address cannot be empty';
        } else {
            const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
            if (!emailRegex.test(signupState.email)) {
                errors.email = 'Please enter a valid email address';
            }
        }

        if (signupState.password.length === 0) {
            errors.password = 'Password Field cannot be empty';
        } else {
            const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
            if (!passwordRegex.test(signupState.password)) {
                errors.password = 'Password must contain at least one digit, one lowercase letter, one uppercase letter, and have a minimum length of 8 characters.';
            }
        }

        if (signupState.confirmpassword.length === 0) {
            errors.confirmpassword = 'Confirm Password Field cannot be empty';
        }

        if (Object.keys(errors).length === 0) {
            if (signupState.password !== signupState.confirmpassword) {
                errors.notMatched = 'Password must be matched'
                setFormErrors(errors)
            } else {
                setFormErrors('')
                await registerUser(signupState)
                    .then(res => {
                        if (res.status === 201) {
                            setPermissionError({ message: res.data.message, status: res.status })
                            setTimeout(() => {
                                setPermissionError('')
                                navigate('/')
                            }, 2000)
                        } else {
                            setPermissionError({ message: res.data.message, status: res.status })
                        }
                    })
            }
        } else {
            setFormErrors(errors)
        }
    }


    // Function to clear the error for a specific field when it's focused
    const clearError = (fieldId) => {
        setFormErrors((prevErrors) => {
            return { ...prevErrors, [fieldId]: '' };
        });
    };

    return (
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            {formErrors.notMatched ?
                <h5 className=' bg-red-500 p-2 text-white'>{formErrors.notMatched}</h5>
                : ''}
            {permissionError ?
                <h5 className={`${permissionError.status === 201 ? 'bg-green-500' : 'bg-red-500'} p-2 text-white`}>{permissionError.message}</h5>
                : ''}
            <div className="-space-y-px">
                {fields.map(field => (
                    <div key={field.id} className="relative">
                        <label htmlFor={field.id} className="sr-only">
                            {field.labelText}
                        </label>
                        <Input
                            key={field.id}
                            type={field.type}
                            handleChange={handleChange}
                            value={signupState[field.id]}
                            labelText={field.labelText}
                            labelFor={field.labelFor}
                            id={field.id}
                            name={field.name}
                            placeholder={field.placeholder}
                        />
                        {formErrors[field.id] && (
                            <div className="absolute top-0 right-0 -mt-6 mr-2 bg-red-500 text-white text-xs p-1 rounded">
                                {formErrors[field.id]}
                            </div>
                        )}
                    </div>
                ))}
            </div>
            <FormAction handleSubmit={handleSubmit} text="Register" />
        </form>








    )
}